module.exports = __webpack_public_path__ + "static/Poppins-Black-0573b9231a8316427ad6e751b52e87a4.ttf";